import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $, hideOverlay, runTeaser } from "@jpj/game-shell";
import { warmUpHighs } from "@jpjj/solver-core";
import { Stage } from "./three/scene";
import { enterRoom, state } from "./game/state";
import { LEVELS } from "./game/levels";
import {
  buildDots, exposeTestHooks, fleeRoom, goNext, goPrev,
  initInteraction, renderHUD, resetRoom, restartGame, startGame,
} from "./game/play";
import { nextCompare, resetReveal, skipCompare, viewOpt, viewYou } from "./reveal/reveal";
import { closeLearn, openLearn, stepLearn } from "./reveal/learn";

const stage = new Stage($("scene"));
initInteraction(stage);
exposeTestHooks();

/* ---------- Nav + controls ---------- */
$("prevBtn").addEventListener("click", goPrev);
$("nextBtn").addEventListener("click", goNext);
$("resetBtn").addEventListener("click", resetRoom);
$("fleeBtn").addEventListener("click", fleeRoom);

/* ---------- Reveal / explainer buttons ---------- */
$("cmpSkip").addEventListener("click", skipCompare);
$("cmpViewYou").addEventListener("click", viewYou);
$("cmpViewOpt").addEventListener("click", viewOpt);
$("cmpNext").addEventListener("click", nextCompare);
$("learnBtn").addEventListener("click", openLearn);
$("again2").addEventListener("click", () => { hideOverlay("endOverlay"); resetReveal(); restartGame(); });
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));

/* ---------- Intro ---------- */
const beginGame = (): void => {
  hideOverlay("introOverlay");
  startGame();
};
$("beginBtn").addEventListener("click", beginGame);

/* ---------- Init ---------- */
runTeaser({ onStart: beginGame });
buildDots();
warmUpHighs();
// preview the first room behind the intro/teaser so the scene looks alive
enterRoom(0);
state.phase = "intro";
stage.loadRoom(LEVELS[0]);
renderHUD();
